import Vue from 'vue'
import VueRouter from 'vue-router'
import Payment from '../pages/Payment/Payment.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Paynetworx-Hosted Payment',
    component: Payment
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
